import { ServiceBagService, ServiceBagServices } from '@base/component/ServiceBag';
import { BasePageComponent } from '@base/component/BasePageComponent';
import { Component } from '@angular/core';
import { BaseState } from '@base/entities/BaseEntities';
import { CityEndpoint } from '@telrun-client/_proxy/endpoints/city.endpoint';
import { CityPackageEndpoint } from '@telrun-client/_proxy/endpoints/citypackage.endpoint';
import { DataSourceCustomAction } from '@base/datalayer/BaseDataSources';
import { City } from '@telrun-client/_proxy/entities/city.entity';
import { Registration } from '@telrun-client/_proxy/entities/registration.entity';
import { RegistrationEndpoint } from '@telrun-client/_proxy/endpoints/registration.endpoint';
import { Globals } from '@telrun-client/_globals';
import { EnumsCityType } from '@telrun-client/_proxy/enums';

class State extends BaseState {
    City: City;
    NetPointNumOption: number = 0;
    MeshOptions: any[] = [];
    NetPointNumOptions: any[] = [];
    Cities: City[] = [];
    CellularPattern: any = /^05\d-\d{7}$/im;
    PhonePattern: any = /^0[2-9]-\d{7}$/im;
 
}
@Component({
    providers: ServiceBagServices,
    selector: 'app-registration',
    templateUrl: './registration.component.html',
    styleUrls: ['./registration.component.scss']
})
export class RegistrationComponent extends BasePageComponent<Registration, State> {
    CityReadOnly = false;
    constructor(A: ServiceBagService,
        private cityEndpoint: CityEndpoint,
        private cityPackageEndpoint: CityPackageEndpoint,
        private registrationEndpoint: RegistrationEndpoint) {
        super(A, 'RegistrationComponent', Registration, State);
    }

    protected override OnInitComponent() {
        if (Globals.Registration) {
            this.Entity = Globals.Registration;
            this.CityUpdated();
        }
        else {
            this.Entity = new Registration();
            this.InitStateFromQuery();
            this.Entity.Status = 0;
            this.Entity.Telefonia = 0;
            this.Entity.ExternalIp = 0;
            this.Entity.RegistrationDate = new Date();
            this.CityUpdated();
        }
        this.LoadCities();
        this.LoadCitiesPackages();
    }

    private LoadCities() {
        this.Do(this.cityEndpoint.GetList(), false, (response) => {
            this.State.Cities = response.Entities;
            if (this.Entity.CityID) {
                this.State.City = this.State.Cities.find((item: City) => item.EntryID === this.Entity.CityID);
                this.CityUpdated();
            }
        });
    }

    private LoadCitiesPackages() {
        if (this.Entity.CityID) {
            this.DataSources['CitiesPackages'] = new DataSourceCustomAction(() => this.cityPackageEndpoint.ListEx(this.Entity.CityID));
        }
    }

    OnCityChanged(event: any) {
        if (!this.IsUIEvent(event)) return;

        this.State.City = this.State.Cities.find((item: City) => item.EntryID === event.value);
        this.Entity.CityPackageID = undefined;
        this.CityUpdated();
    }

    private CityUpdated() {
        if (!this.ShowMeshOption) {
            this.Entity.MeshOption = null;
        }
        if (!this.ShowNetPointNumOption) {
            this.Entity.NetPointNum = null;
        }


        this.LoadCitiesPackages();
        this.State.MeshOptions = this.GetOptions("MeshOptions");
        this.State.NetPointNumOptions = this.GetOptions("NetPointNumOptions");
    }

    GetOptions(propName: string) {
        return (this.State.City && this.State.City[propName].split(',').map(option => ({ name: option, value: +option }))) || []
    }

    get ShowTelefoniaOption(): boolean {
        return this.State.City && !!this.State.City.AllowsTelefonia;
    }

    get ShowExtenalIPOption(): boolean {
        return this.State.City && !!this.State.City.AllowsExtenalIP;
    }

    get ShowMeshOption(): boolean {
        return this.State.City && this.State.MeshOptions.some(item => item.value);
    }

    get ShowNetPointNumOption(): boolean {
        return this.State.City && this.State.NetPointNumOptions.some(item => item.value);
    }


    get PlainTextForIP(): string {
        return this.State.City && this.State.City.PlainTextForIP;
    }

    get IsCityKibbutz(): boolean {
        return this.State.City?.PlaceType === EnumsCityType.Kibbutz
    }

    OnTelefoniaChanged() {
        this.Entity.AddNewTelephoneLine1 = false;
        this.Entity.PhoneNumberForTransfer1 = "";
        this.Entity.AddNewTelephoneLine2 = false;
        this.Entity.PhoneNumberForTransfer2 = "";
    }

    OnNext() {
        if (!this.Entity.MeshOption) {
            this.Entity.MeshOption = 0;
        }

        if (!this.Entity.NetPointNum) {
            this.Entity.NetPointNum = 0;
        }
        this.Do(this.registrationEndpoint.Save(this.Entity), false, (response) => {
            Globals.Registration = response.Entity;
            this.Navigate(['/pages/credit-card']);
        });
    }

    InitStateFromQuery() {
        if (Object.entries(this.QueryParams).length <= 0) return;
        this.QueryParams = this.A.Navigator.GetQueryParams(false);
        if (this.QueryParams.CityID) {
            this.Entity.CityID = +this.QueryParams.CityID;
            this.CityReadOnly = true;
        }
    }

    onCellular2Changed(e: any) {
        let val = e.value.replace(/[^0-9]/g, '');

        if (val.startsWith('05') && val.length >= 3) {
            val = val.slice(0, 3) + '-' + val.slice(3, 10);
        }

        this.Entity.Phone = val;
    }

    onPhoneChanged(e: any) {
        let val = e.value.replace(/[^0-9]/g, '');
         if (val.startsWith('0') && val.length >= 2) {
            val = val.slice(0, 2) + '-' + val.slice(2, 9);
        }

        this.Entity.AdditionalPhone = val;
    }

    onCellularChanged(e: any) {
        let val = e.value.replace(/[^0-9]/g, '');

        if (val.startsWith('05') && val.length >= 3) {
            val = val.slice(0, 3) + '-' + val.slice(3, 10);
        }

        this.Entity.Cellular = val;
    }

}
